require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-07-05-moved-urls-and-software.json") })
        }
      }, "path---articles-2005-07-05-moved-urls-and-software");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-07-05-moved-urls-and-software!./.cache/json/articles-2005-07-05-moved-urls-and-software.json
// module id = 412
// module chunks = 231608221292675